import { orderService } from '../../services/order-service/order-service';
import { getDateTime } from '../../lib/dates';
import { store } from '../../store';
import {
  setHeader,
  setSubHeader,
  setCancellingLabel,
  setTooltipText,
} from '../../actions/itemsPage';
import { a11yPageRedirection } from '../../lib/a11yUtils';
import { escapeRegExp } from '../../lib/stringHelpers';
import { setItemsByReturnDay, setItemReturnQtyByDay } from '../../actions/orderService';
import { returnItemsService } from '../../services/return-items-service/return-items-service';
import { updateStep1Complete, setLoading } from '../../actions/page';
import { toggleTooltip } from '../../actions/tooltip';
import { ActionTypes, ReturnDateViewType } from '../../constants/enums';
import { retailerSettingsService } from '../../services';

export const getStep1HeaderMsg = () => {
  let OE = false;
  let OI = false;
  let RI = false;
  let EOP = false;

  if (orderService.getTotalReturned().total_items > 0) {
    RI = true;
  }
  if (orderService.isOverrideCode()) {
    EOP = true;
  }
  if (orderService.getNaItems().length > 0) {
    OI = true;
  }
  if (orderService.getItems().length > 0) {
    OE = true;
  }

  if (EOP && RI && OE && OI) {
    return 'msg6';
  } else if (OE && OI && RI) {
    return 'msg2';
  } else if (EOP && RI && OI) {
    return 'msg3';
  } else if (EOP && RI && OE) {
    return 'msg6';
  } else if (OE && OI) {
    return 'msg1';
  } else if (OE && RI) {
    return 'msg2';
  } else if (EOP && RI) {
    return 'msg3';
  } else if (EOP && OE) {
    return 'msg5';
  } else if (OE) {
    return 'msg1';
  } else if (RI) {
    return 'msg3';
  } else if (OI) {
    return 'msg4';
  } else if (EOP) {
    return 'msg5';
  }

  return 'msg7';
};

export const templateStrings = () => {
  const {
    language,
    page: { locale },
    claims: { enabled: claimsEnabled },
    returnItems: { cartActions = [] },
  } = store.getState();
  const headerMsg = getStep1HeaderMsg();
  const isIneligibleHeader = headerMsg === 'msg3' || headerMsg === 'msg4';
  let shipmentMainHeader = language[`returns.step_1.header_${headerMsg}.main_msg`] || '';
  let shipmentSubHeader = language[`returns.step_1.header_${headerMsg}.sub_msg`] || '';

  if (!isIneligibleHeader && cartActions.includes(ActionTypes.Claim)) {
    shipmentMainHeader = language['step_1.item_selection_header.additional_missing_items'];
    shipmentSubHeader = '';
  } else if (!isIneligibleHeader && claimsEnabled) {
    shipmentMainHeader = language['step_1.item_selection_header'];
  }

  const replacedShipmentMainHeader = shipmentMainHeader
    .replace(
      new RegExp(escapeRegExp('$orderNumber'), 'g'),
      orderService.getOrder().order_info.order_number,
    )
    .replace(
      new RegExp(escapeRegExp('$totalItems'), 'g'),
      orderService.getTotalReturned().total_items,
    );

  const replacedShipmentSubHeader = shipmentSubHeader
    .replace(
      new RegExp(escapeRegExp('$orderNumber'), 'g'),
      orderService.getOrder().order_info.order_number,
    )
    .replace(
      new RegExp(escapeRegExp('$totalItems'), 'g'),
      orderService.getTotalReturned().total_items,
    );
  const formattedDate = orderService.getReturnDate();
  const step1Header = replacedShipmentMainHeader.replace(
    new RegExp(escapeRegExp('$returnByDate'), 'g'),
    formattedDate,
  );
  const step1SubHeader = replacedShipmentSubHeader.replace(
    new RegExp(escapeRegExp('$returnByDate'), 'g'),
    formattedDate,
  );
  store.dispatch(setHeader(step1Header));
  a11yPageRedirection(language, step1Header);
  store.dispatch(setSubHeader(step1SubHeader));
  const itemsByReturnDay = orderService.getItemsByReturnDay();
  if (itemsByReturnDay && itemsByReturnDay.length) {
    const updatedItemsByReturnDay = itemsByReturnDay.map((day) => {
      day.step_1_subheader = replacedShipmentSubHeader.replace(
        new RegExp(escapeRegExp('$returnByDate'), 'g'),
        getDateTime({
          locale,
          date: day.date,
          options: {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          },
        }),
      );
    });
    setItemsByReturnDay(updatedItemsByReturnDay);
  }

  if (retailerSettingsService.getReturnDateViewType() === ReturnDateViewType.ItemsCard) {
    store.dispatch(setSubHeader(''));
  }
};

export const updateSubmitStatus = () => {
  const {
    page: { productType, itemsDisclaimerChecked } = {},
    returnsSettings: { [productType]: { itemsDisclaimerCheckbox = {} } = {} } = {},
  } = store.getState();
  if (returnItemsService.getTotalSelected() < 1) {
    return store.dispatch(updateStep1Complete(false));
  }
  if (itemsDisclaimerCheckbox.enabled && itemsDisclaimerCheckbox.required) {
    return store.dispatch(updateStep1Complete(itemsDisclaimerChecked));
  }
  return store.dispatch(updateStep1Complete(true));
};

export const refreshOrder = () => {
  orderService.validateOrder().then(() => {
    // Refresh all items
    store.dispatch(setItemReturnQtyByDay(orderService.getReturnAndEligibleByDate(false)));

    // Refresh header messages
    window.setTimeout(() => {
      templateStrings();
    }, 100);
    window.setTimeout(() => {
      getStep1HeaderMsg();
    }, 100);

    templateStrings();

    // Hide loading bar
    store.dispatch(setLoading(false));
    store.dispatch(setCancellingLabel(false));
  });
};

export const triggerCancelReturnErrorTooltip = (errorMsg) => {
  const { tooltip } = store.getState();
  const tooltipState = tooltip.step1ErrorTooltip;
  store.dispatch(setTooltipText(errorMsg));

  if (!tooltipState) {
    store.dispatch(toggleTooltip('step1ErrorTooltip'));
  }
};

export const triggerIneligibilityTooltip = (item) => {
  const { tooltip } = store.getState();
  const tooltipState = tooltip.step1ErrorTooltip;
  const { ineligibilityInfo } = item;
  item.selected = false;
  item.itemWarning = ineligibilityInfo.status;
  store.dispatch(setTooltipText(ineligibilityInfo.tooltip));

  if (!tooltipState) {
    store.dispatch(toggleTooltip('step1ErrorTooltip'));
  }
};
